(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    api.initCartCount(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  // 购物车角标：替代 index.js 对 cart.updated 的监听，兼容 Ajax 加购后的数量刷新。
  function initCartCount(documentRoot) {
    var badges = documentRoot.querySelectorAll('.cart-items-count');

    if (!badges.length) return;

    documentRoot.addEventListener('cart.updated', function (event) {
      var detail = event.detail || {};
      var itemCount = Number(detail.item_count) || 0;

      Array.prototype.forEach.call(badges, function (badge) {
        badge.classList.toggle('show', itemCount > 0);
        badge.textContent = itemCount > 0 ? (itemCount > 99 ? '99+' : String(itemCount)) : '';
      });
    });
  }

  return { initCartCount: initCartCount };
});
